var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 753,
    height: 347,
    viewBox: "0 0 753 347",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.9 232.3H208.9V280.4H183.9V303H173.4V341.4H121.4V303H131.9V280.4H30V232.3L40.6 207.3H30.1L115.7 4.80002H173.4V157H183.9V232.3ZM131.9 157.1H121.4V105.9L78.6 207.3H89.1L78.6 232.3H131.9V157.1Z",
    fill: "#00E68A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.3 83.6C437.3 84.2667 437.3 84.9333 437.3 85.6V260.6C437.3 314.5 408.9 345.3 357 345.3C305.2 345.3 276.8 314.6 276.7 260.9H266.2V85.6C266.2 31.7 294.5 1 346.5 1C397.8 1 426.1 31 426.8 83.6H437.3ZM384.4 83.6H373.9V82.2C373.9 58.2 363.3 49 346.4 49C329.6 49 319 58.2 319 82.2V260.9H329.6V264C329.6 288 340.2 297.2 357 297.2C373.8 297.2 384.4 288 384.4 264V83.6Z",
    fill: "#FB607F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M675.4 232.3V280.4H650.4V341.4H598.4V280.4H496.5V232.3L521.5 173.1H532.1L603.2 4.80002H660.9V217H650.4V232.3H675.4ZM609 105.8L580.5 173.1H570L545.1 232.3H598.4V217H609V105.8Z",
    fill: "#FB607F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.9 232.3H249.9V280.4H224.9V303H214.4V341.4H162.5V303H173V280.4H71V232.3L81.6 207.3H71.1L156.7 4.80002H214.4V157H224.9V232.3ZM173 232.3V157.1H162.5V105.9L119.6 207.3H130.2L119.6 232.3H173Z",
    fill: "#FF2782"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.3 83.6C478.367 84.2667 478.4 84.9333 478.4 85.6V260.6C478.4 314.5 450 345.3 398 345.3C346.2 345.3 317.8 314.6 317.7 260.9H307.2V85.6C307.2 31.7 335.6 1 387.5 1C438.8 1 467.2 31 467.8 83.6H478.3ZM425.4 83.6H414.9V82.2C414.9 58.2 404.3 49 387.5 49C370.7 49 360.1 58.2 360.1 82.2V260.9H370.6V264C370.6 288 381.2 297.2 398 297.2C414.8 297.2 425.4 288 425.4 264V83.6Z",
    fill: "#FF2782"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M716.4 232.3V280.4H691.4V341.4H639.5V280.4H537.6V232.3L562.6 173.1H573.1L644.2 4.80002H702V217H691.4V232.3H716.4ZM650 217V105.8L621.6 173.1H611.1L586.1 232.3H639.5V217H650Z",
    fill: "#FF2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.7 187H354.6V173.1H371.7V187Z",
    fill: "#FF2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.9 125.2H445.8V111.4H472.9V125.2Z",
    fill: "#FF2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.5 43.1H668.4V29.2H695.5V43.1Z",
    fill: "#FF2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.5 118.3H698.9V104.4H745.5V118.3Z",
    fill: "#FF2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.3 247.1H328.8V233.2H353.3V247.1Z",
    fill: "#FF2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.4 241.9H472.9V228.1H497.4V241.9Z",
    fill: "#FF2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.2 335.7H256.4V321.8H270.2V335.7Z",
    fill: "#FF2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.2 31.9H571.3V18.1H585.2V31.9Z",
    fill: "#FF2782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.5 254H738.6V240.1H752.5V254Z",
    fill: "#FF2782"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.9 232.3H239.9V280.4H214.9V303H204.4V341.4H152.5V303H163V280.4H61V232.3L71.6 207.3H61.1L146.7 4.80002H204.4V157H214.9V232.3ZM163 232.3V157.1H152.5V105.9L109.6 207.3H120.2L109.6 232.3H163Z",
    fill: "#FF2782"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M467.3 84.6C467.367 85.2667 467.4 85.9333 467.4 86.6V261.6C467.4 315.5 439 346.3 387 346.3C335.2 346.3 306.8 315.6 306.7 261.9H296.2V86.6C296.2 32.7 324.6 2 376.5 2C427.8 2 456.2 32 456.8 84.6H467.3ZM414.4 84.6H403.9V83.2C403.9 59.2 393.3 50 376.5 50C359.7 50 349.1 59.2 349.1 83.2V261.9H359.6V265C359.6 289 370.2 298.2 387 298.2C403.8 298.2 414.4 289 414.4 265V84.6Z",
    fill: "#FF2782"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M706.4 232.3V280.4H681.4V341.4H629.5V280.4H527.6V232.3L552.6 173.1H563.1L634.2 4.80002H692V217H681.4V232.3H706.4ZM640 217V105.8L611.6 173.1H601.1L576.1 232.3H629.5V217H640Z",
    fill: "#FF2782"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.9 232.3H218.9V280.4H193.9V303H183.4V341.4H131.4V303H141.9V280.4H40V232.3L50.6 207.3H40.1L125.7 4.80002H183.4V157H193.9V232.3ZM141.9 157.1H131.4V105.9L88.6 207.3H99.1L88.6 232.3H141.9V157.1Z",
    fill: "#FB607F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M447.3 82.6C447.3 83.2667 447.3 83.9333 447.3 84.6V259.6C447.3 313.5 418.9 344.3 367 344.3C315.2 344.3 286.8 313.6 286.7 259.9H276.2V84.6C276.2 30.7 304.5 0 356.5 0C407.8 0 436.1 30 436.8 82.6H447.3ZM394.4 82.6H383.9V81.2C383.9 57.2 373.3 48 356.4 48C339.6 48 329 57.2 329 81.2V259.9H339.6V263C339.6 287 350.2 296.2 367 296.2C383.8 296.2 394.4 287 394.4 263V82.6Z",
    fill: "#FB607F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M685.4 232.3V280.4H660.4V341.4H608.4V280.4H506.5V232.3L531.5 173.1H542.1L613.2 4.80002H670.9V217H660.4V232.3H685.4ZM619 105.8L590.5 173.1H580L555.1 232.3H608.4V217H619V105.8Z",
    fill: "#FB607F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.4 232.3H229.4V280.4H204.4V303H193.9V341.4H141.9V303H152.5V280.4H50.5V232.3L61.1 207.3H50.6L136.2 4.80002H193.9V157H204.4V232.3ZM152.5 232.3V157.1H141.9V105.9L99.1 207.3H109.6L99.1 232.3H152.5Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M457.8 83.6C457.8 84.2667 457.8 84.9333 457.8 85.6V260.6C457.8 314.5 429.5 345.3 377.5 345.3C325.7 345.3 297.3 314.6 297.2 260.9H286.7V85.6C286.7 31.7 315.1 1 367 1C418.3 1 446.6 31 447.3 83.6H457.8ZM404.9 83.6H394.4V82.2C394.4 58.2 383.8 49 367 49C350.2 49 339.6 58.2 339.6 82.2V260.9H350.1V264C350.1 288 360.7 297.2 377.5 297.2C394.3 297.2 404.9 288 404.9 264V83.6Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M695.9 232.3V280.4H670.9V341.4H619V280.4H517V232.3L542.1 173.1H552.6L623.7 4.80002H681.4V217H670.9V232.3H695.9ZM629.5 217V105.8L601.1 173.1H590.5L565.6 232.3H619V217H629.5Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M239.9 157H178.4V143.2H239.9V157Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M380.3 260.9H318.8V247.1H380.3V260.9Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M482.5 111.4H435.8V97.5H482.5V111.4Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M480.8 228.1H434.1V214.2H480.8V228.1Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M361.7 187H344.6V173.1H361.7V187Z",
    fill: "#FF2782"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M316 211.6H281V197.8H316V211.6Z",
    fill: "#FB607F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M659.4 185.4H624.4V171.6H659.4V185.4Z",
    fill: "#FB607F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M318.8 50H260.2V36.2H318.8V50Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M462.9 125.2H435.8V111.4H462.9V125.2Z",
    fill: "#FF2782"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M685.5 43.1H658.4V29.2H685.5V43.1Z",
    fill: "#FF2782"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M735.5 118.3H688.9V104.4H735.5V118.3Z",
    fill: "#FF2782"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M412.2 139.1H398.3V125.2H412.2V139.1Z",
    fill: "#FB607F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M718.2 308H634.8V294.1H718.2V308Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M630.1 62.9H522.1V49H630.1V62.9Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M543.5 260.9H500.8V247.1H543.5V260.9Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1 153.5H0V139.6H99.1V153.5Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M212.3 57H179.9V43.1H212.3V57Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M294.3 293.4H261.9V279.5H294.3V293.4Z",
    fill: "#FB607F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M312.2 307.2H279.8V293.4H312.2V307.2Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 181.2H30.4V167.4H50.5V181.2Z",
    fill: "#FB607F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M343.3 247.1H318.8V233.2H343.3V247.1Z",
    fill: "#FF2782"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M487.4 241.9H462.9V228.1H487.4V241.9Z",
    fill: "#FF2782"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M469.3 317.5H425.7V312.3H469.3V317.5Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M296 127.9H260.2V122.6H296V127.9Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M547 100.1H508.1V94.9H547V100.1Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M434.9 14.9H396V9.60001H434.9V14.9Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M225.5 218.2H189.5V212.9H225.5V218.2Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M247.7 88.8H232.6V83.6H247.7V88.8Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M138.4 72.5H80.8V67.2H138.4V72.5Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M109.6 310.6H91.4V305.4H109.6V310.6Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M701.2 155.5H676.5V150.3H701.2V155.5Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M574.6 152.7H535.6V147.5H574.6V152.7Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M417.8 199.5H378.8V194.2H417.8V199.5Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M747.5 199.5H713.5V194.2H747.5V199.5Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M592.2 331.4H566.4V326.1H592.2V331.4Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M462.9 14.9H453.4V9.60001H462.9V14.9Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M260.2 335.7H246.4V321.8H260.2V335.7Z",
    fill: "#FF2782"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M575.2 31.9H561.3V18.1H575.2V31.9Z",
    fill: "#FF2782"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M742.5 254H728.6V240.1H742.5V254Z",
    fill: "#FF2782"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9 74H40V60.2H53.9V74Z",
    fill: "#FB607F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M534.5 321.8H520.6V308H534.5V321.8Z",
    fill: "#FB607F"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M504 166.8H490.2V152.9H504V166.8Z",
    fill: "#FB607F"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M497.1 56H483.2V42.1H497.1V56Z",
    fill: "#FB607F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/error404.2d0209f9be2762840f19c8c400c20b36.svg";
export { ForwardRef as ReactComponent };